import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useMe } from "@/context/AuthContext";
import { useI18n } from "@/i18n/I18nProvider";

const FavCtx = createContext(null);

export function FavoritesProvider({ children }) {
  const { me } = useMe();
  const [ids, setIds] = useState(new Set());

  useEffect(() => {
    if (!me) { setIds(new Set()); return; }
    api.get("/favorites/ids").then((r) => setIds(new Set(r.data))).catch(() => {});
  }, [me]);

  const toggle = useCallback(async (pid) => {
    const has = ids.has(pid);
    setIds((s) => { const n = new Set(s); has ? n.delete(pid) : n.add(pid); return n; });
    try {
      has ? await api.delete(`/favorites/${pid}`) : await api.post(`/favorites/${pid}`);
    } catch {
      setIds((s) => { const n = new Set(s); has ? n.add(pid) : n.delete(pid); return n; });
    }
  }, [ids]);

  return <FavCtx.Provider value={{ ids, toggle, enabled: !!me }}>{children}</FavCtx.Provider>;
}

export function useFavorite(pid) {
  const { ids, toggle, enabled } = useContext(FavCtx);
  const navigate = useNavigate();
  const { t } = useI18n();
  const onToggle = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    if (!enabled) { toast(t("details.loginToFav")); navigate("/sign-in"); return; }
    toggle(pid);
  };
  return { active: ids.has(pid), onToggle };
}
